// extracted by mini-css-extract-plugin
module.exports = {"badge":"index_badge__rUces","voucher":"index_voucher__Faq_p","label":"index_label__sY_3W","cash":"index_cash___nf_n","icon":"index_icon__hpx4H"};